<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-btn @click="close" x-small outlined class="mt-2 mb-3 primary white--text">
          <v-icon x-small class="mr-2">mdi-arrow-left</v-icon>{{ $t('1') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 mt-1>
        <v-layout wrap>
          <v-flex x8>
            <b style="font-size:1.4em">{{ isEducationNotCertification ? $t('2education') : $t('2certification') }}</b>
            <!-- <v-chip color="orange" class="white--text ml-1 mb-6" x-small><v-icon class="mr-1" x-small>mdi-shimmer</v-icon>{{ $t('2bis') }}</v-chip> -->
          </v-flex>
          <v-flex xs4 text-end pr-6 pt-1>
            <span @click="isShowingVideoDialog = true" style="cursor:hand">
              <v-icon small style="padding-bottom: 2px">mdi-play-circle</v-icon>
              <span class="ml-1 textAsLink">{{ $t('video0') }}</span>
            </span>
          </v-flex>
        </v-layout>
        <div><b>{{ isEducationNotCertification ? $t('3education') : $t('3certification') }}</b></div>
        <div><span v-html="isEducationNotCertification ? $t('4education') : $t('4certification')"/></div>
        <div class="mt-4"><b>{{ $t('6') }}</b></div>
        <div v-if="isCurrentProfileEducationOrCertificationEmpty">
          <div>{{ isEducationNotCertification ? $t('7bisEducation') : $t('7bisCertification') }}</div>
          <div>{{ $t('8bis') }}</div>
        </div>
        <div v-else>
          <div>{{ isEducationNotCertification ? $t('7education') : $t('7certification') }}</div>
          <div>{{ $t('8') }}</div>
        </div>
      </v-flex>
      <v-flex xs12>
        <div v-if="errorWhileParsing" class="orange--text mt-2">
          <div>{{ isEducationNotCertification ? $t('9education') : $t('9certification') }}</div>
          <div v-if="errorWhileParsingErrorType === 'too_many_tokens'">
            {{ $t('10b') }}
          </div>
          <div v-else>
            {{ $t('10') }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 mt-4>
        <div class="text-end">
          <v-btn style="position: absolute; right: 27px; margin-top: 10px; z-index:0" @click="parse" :disabled="!entireEducationOrCertificationQuillStr.trim() || isParsingPending" class="secondary mr-4">{{ $t('11') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-1 mb-6">
      <vue-editor ref="editor" v-model="entireEducationOrCertificationQuillStr" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>  
    </div>

    <v-dialog v-model="isParsingPending" width="40%" persistent content-class="vDialogWithoutShadow">
      <v-layout wrap mb-6>
        <v-flex xs12 text-center>
          <v-avatar :size="225" color="primary">
            <img :src="images.main" class="mb-1">
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
        <div><b>{{ isEducationNotCertification ? $t('12education') : $t('12certification') }}</b></div>
        <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingVideoDialog" height="90%" width="80%">
      <v-card class="pa-2 text-center" v-if="isShowingVideoDialog">
        <h3 class="mb-2 mt-2">{{ $t('video1') }}</h3>
        <video
          controls
          loop
          autoplay
          width="100%"
          height="600px"
          src="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FExtraction%20d'un%20diplo%CC%82me%20ou%20d'une%20formation.mov?alt=media&token=d9b27d4e-3a46-48d5-b7f6-ae4eccbe7bf8"
        />
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  components: {
    VueEditor
  },
  props: {
    profile: Object,
    index: Number,
    isFromToken: Boolean,
    isEducationNotCertification: Boolean
  },
  data: () => ({
    entireEducationOrCertificationQuillStr: '',
    editorToolbar: [[{ list: "bullet" }]],
    editorOptions: {
      formats: ['list', 'indent'],
      modules: { keyboard: { bindings: { 'tab': { key: 9, handler: function() { return false; } } } } }
    },
    isParsingPending: false,
    errorWhileParsing: false,
    errorWhileParsingErrorType: null,
    images: {
      main: require('@/assets/app/images/Science_Outline.svg')
    },
    isShowingVideoDialog: false
  }),
  computed:{
    isCurrentProfileEducationOrCertificationEmpty() {
      const educationOrCertification = this.isEducationNotCertification ? this.profile.educations[this.index] : this.profile.certifications[this.index]
      return !educationOrCertification.startYear && !educationOrCertification.endYear && !educationOrCertification.institute && !educationOrCertification.description
    }
  },
  methods: {
    async parse() {
      this.errorWhileParsing = false
      this.errorWhileParsingErrorType = null
      this.isParsingPending = true
      let educationOrCertification;
      if (this.isFromToken) {
        const response = await axios.post(`${functionsUrlBase}/parseEntireEducationOrCertificationFromToken?dossierId=${this.$route.params.dossierId}&accessToken=${this.$route.query.accessToken}`, {
          entireEducationOrCertificationQuillStr: this.entireEducationOrCertificationQuillStr
        })
        if (response.data.success) {
          educationOrCertification = response.data.educationOrCertification
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      } else {
        const response = (await this.$functions.httpsCallable('parseEntireEducationOrCertification')({
          entireEducationOrCertificationQuillStr: this.entireEducationOrCertificationQuillStr,
          dossierId: this.$route.params.dossierId
        }))
        if (response.data.success) {
          educationOrCertification = response.data.educationOrCertification
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      }
      
      if (this.isEducationNotCertification) {
        this.profile.educations[this.index] = educationOrCertification
      } else {
        this.profile.certifications[this.index] = educationOrCertification
      }
      this.close()
      this.isParsingPending = false
    },
    close() {
      this.$emit('setIsUsingSelectEntireEducationOrCertification', { isUsingSelectEntireEducationOrCertification: false } )
    },
  },
  watch: {
    entireEducationOrCertificationQuillStr: {
      handler(val) {
        if (val.includes('<li>')) {
          this.entireEducationOrCertificationQuillStr = val.replace(/<li>/g, '<li class="ql-indent-0">')
        }
      }
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "1": "Revenir au formulaire",
    "2education": "Extraction d'un diplôme",
    "2certification": "Extraction d'une certification",
    "2bis": "Beta",
    "3education": "Copiez-collez tout le diplôme",
    "3certification": "Copiez-collez toute la certification",
    "4education": "<span>Copiez dans le CV original <b>tout le texte</b> lié à ce diplôme, puis collez-le ci-dessous.</span>",
    "4certification": "<span>Copiez dans le CV original <b>tout le texte</b> lié à cette certification, puis collez-le ci-dessous.</span>",
    "6": "Puis cliquez sur \"Extraire\"",
    "7education": "Notre algorithme va identifier tous les champs du diplôme à partir de son texte.",
    "7certification": "Notre algorithme va identifier tous les champs de la certification à partir de son texte.",
    "8": "Tous les champs existants seront écrasés : années de début et de fin, institut, description.",
    "7bisEducation": "Notre algorithme va identifier tous les champs du diplôme à partir de son texte :",
    "7bisCertification": "Notre algorithme va identifier tous les champs de la certification à partir de son texte :",
    "8bis": "année de début, année de fin, institut et description.",
    "9education": "Erreur lors de l'extraction du diplôme.",
    "9certification": "Erreur lors de l'extraction de la certification",
    "10": "Sincèrement désolé. Nous améliorons la fonctionnalité après chaque erreur comme celle-ci.",
    "10b": "Le texte sélectionné est trop long.",
    "11": "Extraire",
    "12education": "Analyse du diplôme en cours...",
    "12certification": "Analyse de la certification en cours...",
    "video0": "Voir un exemple",
    "video1": "Comment sélectionner un diplôme ou une certification d'un seul coup"
  },
  "en": {
    "1": "Back to the form",
    "2education": "Extraction of a diploma",
    "2certification": "Extraction of a certification",
    "2bis": "Beta",
    "3education": "Copy-paste the entire diploma",
    "3certification": "Copy-paste the entire certification",
    "4education": "<span>Copy in the original CV <b>all the text</b> related to this diploma, then paste it below.</span>",
    "4certification": "<span>Copy in the original CV <b>all the text</b> related to this certification, then paste it below.</span>",
    "6": "Then click on \"Extract\"",
    "7education": "Our algorithm will identify all the fields of the diploma from its text.",
    "7certification": "Our algorithm will identify all the fields of the certification from its text.",
    "8": "All the existing fields will be overwritten: start date, end date, institute and description.",
    "7bisEducation": "Our algorithm will identify all the fields of the diploma from its text:",
    "7bisCertification": "Our algorithm will identify all the fields of the certification from its text:",
    "8bis": "start date, end date, institute and description.",
    "9education": "Error while extracting the diploma.",
    "9certification": "Error while extracting the certification.",
    "10": "Sorry about that. We improve this feature after each error like this one.",
    "10b": "The selected text is too long.",
    "11": "Extract",
    "12education": "Analyzing the diploma...",
    "12certification": "Analyzing the certification...",
    "video0": "See an example",
    "video1": "How to extract an entire diploma or certification at once"
  }
}
</i18n>